import { clickOutside } from '../click-events/click-outside'

const $doc = $(document)

$doc.on('click', function (e) {
  clickOutside(e, 'js-dropdown', 'is-expanded', 'js-btn-toggle-dropdown')
})
